import React from 'react';
import { X } from 'lucide-react';
import { VideoPlayer } from './VideoPlayer';

interface VideoModalProps {
  isOpen: boolean;
  onClose: () => void;
  projectId: string;
  storagePath: string | null;
  customerName: string;
}

export function VideoModal({ isOpen, onClose, projectId, storagePath, customerName }: VideoModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex min-h-screen items-center justify-center px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" onClick={onClose} />

        <div className="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-4xl sm:w-full sm:p-6">
          <div className="absolute top-0 right-0 pt-4 pr-4">
            <button
              onClick={onClose}
              className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-brand-orange focus:ring-offset-2"
            >
              <X className="h-6 w-6" />
            </button>
          </div>

          <div>
            <h2 className="text-lg font-medium leading-6 text-brand-teal mb-4">
              Interview with {customerName}
            </h2>
            {storagePath ? (
              <VideoPlayer 
                projectId={projectId} 
                storagePath={storagePath}
              />
            ) : (
              <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
                <p className="text-sm text-yellow-800">
                  No video available for this interview.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}